import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BibleAnswers from "@/pages/BibleAnswers";
import SharedAnswer from "@/pages/SharedAnswer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BibleAnswers />} />
          <Route path="/a/:id" element={<SharedAnswer />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
